import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class UpdateFiscalDataUserCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }
  async run(update_user_id, business_name, business_id, postal_address, post_code, province): Promise<any> { 
    let args = {
      update_user_id: update_user_id,
      business_name: business_name,
      business_id: business_id,
      postal_address: postal_address,
      post_code: post_code,
      province: province
    };
    try {
      return await this.dispatcher.dispatch('update.fiscal.data.user', args);
    } catch(error) {
      console.error('Error al actualizar datos fiscales', error)
    }
  }
}
